import { notificationViwed } from '../../helpers/api/api';
import { call } from '../../helpers/api/meta'

export const PATCH_NOTIFICATION_VIEW = 'PATCH_NOTIFICATION_VIEW';


export const callPatchNotificationView= (inputs) => {
    const meta = {
      endpoint: (inputs) => notificationViwed(inputs),
      inputs,
      action: PATCH_NOTIFICATION_VIEW,
      messages: {
        id: 'patchNotifyViewData',
        failure: 'Could not update data'
      }
    }
    return call(meta)
  }
  